import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "", stack: "" };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      message: error?.message || String(error),
      stack: error?.stack || "",
    };
  }

  componentDidCatch(error, info) {
    // Surface to console for debugging
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] App crashed:", error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="app-error-boundary"
        style={{
          minHeight: "100vh",
          background: "#08080c",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          fontFamily: "'Space Grotesk', system-ui, sans-serif",
        }}
      >
        <div
          style={{
            maxWidth: 640,
            width: "100%",
            background: "rgba(18,18,28,0.95)",
            border: "1px solid rgba(255,255,255,0.12)",
            borderRadius: 20,
            padding: "32px",
            boxShadow: "0 0 40px rgba(255,0,85,0.15)",
          }}
        >
          <div style={{ fontFamily: "'Bangers', cursive", fontSize: 40, color: "#ff0055", letterSpacing: 1 }}>
            SPIDER-SENSE TINGLING
          </div>
          <p style={{ color: "#a0a0b0", marginTop: 8 }}>
            Something glitched in the multiverse. Here's what happened:
          </p>
          <pre
            style={{
              marginTop: 16,
              background: "#08080c",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: 12,
              padding: 16,
              color: "#00f0ff",
              fontSize: 13,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              maxHeight: 260,
              overflow: "auto",
            }}
          >
            {this.state.message}
            {this.state.stack ? "\n\n" + this.state.stack : ""}
          </pre>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 20,
              background: "#ff0055",
              color: "#fff",
              border: "none",
              borderRadius: 999,
              padding: "12px 28px",
              fontWeight: 700,
              textTransform: "uppercase",
              cursor: "pointer",
            }}
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
